import { render } from "./LinkHandler.vue?vue&type=template&id=2b77dbb0&scoped=true&ts=true"
import script from "./LinkHandler.vue?vue&type=script&lang=ts"
export * from "./LinkHandler.vue?vue&type=script&lang=ts"

import "./LinkHandler.vue?vue&type=style&index=0&id=2b77dbb0&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b77dbb0"]])

export default __exports__